(function () {
  var SEEN_KEY = 'tf_trust_seen';

  function readSeen() {
    try {
      return JSON.parse(sessionStorage.getItem(SEEN_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeSeen(seen) {
    try {
      sessionStorage.setItem(SEEN_KEY, JSON.stringify(seen));
    } catch (error) {}
  }

  function revealPool(pool) {
    if (pool.dataset.trustResolved === '1') return;

    var cards = Array.prototype.slice.call(pool.querySelectorAll('[data-trust-card]'));
    if (!cards.length) return;

    var seen = readSeen();
    var allIndexes = cards.map(function (_, index) {
      return index;
    });
    var availableIndexes = allIndexes.filter(function (index) {
      return seen.indexOf(index) === -1;
    });

    if (!availableIndexes.length) {
      availableIndexes = allIndexes.slice();
      seen = [];
    }

    var selectedIndex = availableIndexes[Math.floor(Math.random() * availableIndexes.length)];

    cards.forEach(function (card, index) {
      card.hidden = index !== selectedIndex;
    });

    seen.push(selectedIndex);
    while (seen.length > Math.max(1, cards.length - 1)) {
      seen.shift();
    }
    writeSeen(seen);

    pool.dataset.trustResolved = '1';
  }

  function run(root) {
    (root || document).querySelectorAll('[data-trust-pool]').forEach(revealPool);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-trust-pool]').forEach(function (pool) {
      pool.dataset.trustResolved = '';
    });
    run(event.target);
  });
})();
